import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=e5bc3862&scoped=true"
import script from "./NoticeBar.vue?vue&type=script&lang=js"
export * from "./NoticeBar.vue?vue&type=script&lang=js"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=e5bc3862&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bc3862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5bc3862')) {
      api.createRecord('e5bc3862', component.options)
    } else {
      api.reload('e5bc3862', component.options)
    }
    module.hot.accept("./NoticeBar.vue?vue&type=template&id=e5bc3862&scoped=true", function () {
      api.rerender('e5bc3862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/inc/NoticeBar.vue"
export default component.exports